import RegExp from '@/constants/regExp';

/** Formik FieldArray Id로 데이터 변경시 사용 */
const useFieldArrayId = (id) => {
  const splitted = id.split(RegExp.specialCharacters).filter(Boolean);

  return splitted.length > 3
    ? splitted
    : {
        name: splitted[0],
        index: splitted[1],
        key: splitted[2],
      };
};

// single \ is a escape character for the regex.
// escape character 입력되었는데, text character가 존재하지 않는경우에 생기는 에러 방지하기 위해 필요.
const handleEscapeCharacters = (string) => {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};
export { useFieldArrayId, handleEscapeCharacters };
